
import axios from 'axios';
// export const server_ip = 'https://test.oasys.com.cy:443/test/api';
// const server_ip = 'http://localhost:43752/api';

export const getOptionChoises = async (server_ip, token) => {

    await axios.get(`${server_ip}/api/options/optionschoices/`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((response) => {
            //console.log(response.data)
            // update the Items context
            return response.data;
        })
        .catch((error) => {
            console.log(error)
            return [];
        })

}

// export const deleteSurvey = async (server_ip, token) => {

//     await axios.get(`${server_ip}/api/options/optionschoices/`, {
//         headers: {
//             Authorization: `Bearer ${token}`
//         }
//     })
//         .then((response) => {
//             //console.log(response.data)
//             // update the Items context
//             return response.data;
//         })
//         .catch((error) => {
//             console.log(error)
//             return [];
//         })

// }



export async function deleteSurvey(server_ip, id, token) {
    try {
        var fetchCmd = server_ip + "api/surveys/deleteSurv";
        const response = await axios.delete(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` },
            params: { id: id }
        });
        console.log(response)
        return response.data;
    } catch (error) {
        console.info(error)
        return [];
    }
}

export async function getSurveyById(server_ip, id) {
    try {
        var fetchCmd = server_ip + "api/surveys/" + id;
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.log(error)
        return [];
    }
}

export async function getSectionBySurveyId(server_ip, id) {
    try {
        var fetchCmd = server_ip + "api/Sections/survey/" + id;
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` }
        });
        //  console.log(fetchCmd + 'response  ', response)
        return response.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function getQuestionsBySectionId(server_ip, id) {
    try {
        var fetchCmd = server_ip + "api/Questions/survey/" + id;
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` }
        });
        // console.log(fetchCmd + 'response  ', response)
        return response.data;
    } catch (error) {
        return [];
    }
}

export async function getOptionsBySurveyId(server_ip, id) {
    try {
        var fetchCmd = server_ip + "api/Options/survey/" + id;
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` }
        });
        // console.log(fetchCmd + 'response  ', response)
        return response.data;
    } catch (error) {
        return [];
    }
}

export async function getQuestionType(server_ip, id) {
    try {
        var fetchCmd = server_ip + "api/Questions/type/" + id;
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` }
        });
        // console.log(fetchCmd + 'response  ', response)
        return response.data;
    } catch (error) {
        return [];
    }
}

export async function getOptionsByQuestionId(server_ip, id) {

    try {
        var fetchCmd = server_ip + "api/options/question/" + id;
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` }
        });
        // console.log(fetchCmd + 'response  ', response)
        return response.data;
    } catch (error) {
        throw new Error(error)
    }
}

export async function postSurvey(server_ip, token, survey, update, hasResponses = 0, notify, redirect, refresh) {
    // console.log(survey)

    const data = {
        sh: survey[0],
        ss: survey[1],
        isUpdate: update,
        hasResponses: hasResponses,
    }

    // console.log(data);
    await axios.post(`${server_ip}api/Surveys/saveNew`, data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
    })
        .then(response => {
            console.log(response)
            return true;
        })
        .catch(error => {
            console.error('There was an error!', error);
            throw new Error(error)
        });
}

export async function postResponses(server_ip, token, response, userSurveySectionList) {
    const data = {
        answers: response,
        userSurveySections: userSurveySectionList,
    }
    console.log(data);
    axios.post(`${server_ip}api/surveysresponse/userresponse`, data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
        },
    })
        .then(response => {
            console.log(response)
            return true;
        })
        .catch(error => {
            console.error('There was an error!', error);
            throw new Error(error)
        });
}

export async function loadSurvey(server_ip, id, token) {
    try {
        var fetchCmd = server_ip + "api/surveys/loadSurv";
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` },
            params: { id: id }
        });
        console.log(response.data)
        return response.data;
    } catch (error) {
        console.info(error)
        return [];
    }
}

export async function loadEverySurvey(server_ip, token) {
    try {
        var fetchCmd = server_ip + "api/surveys/createSurv";
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` },
            params: {}
        });
        return response.data;
    } catch (error) {
        console.log(error)
        return [];//should be empty
    }
}

export async function loadEverySurveyForUser(server_ip, token, emplId) {
    try {
        var fetchCmd = server_ip + "api/surveys/getUserSurveys";
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` },
            params: { emplId: emplId }
        });
        return response.data;
    } catch (error) {
        console.log(error)
        return [];
    }
}

export async function loadSurveyResponses(server_ip, id, token) {
    try {
        var fetchCmd = server_ip + "api/surveysresponse/allsurvuserresponses";
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` },
            params: { survId: id }
        });
        //console.log(response.data)
        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(error)
    }
}

export async function getNumberOfUsersForSurveyResponses(server_ip, id, token) {
    try {
        var fetchCmd = server_ip + "api/surveysresponse/numberOfSurveyAnswers";
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` },
            params: { survId: id }
        });
        //console.log(response.data)
        return response.data;
    } catch (error) {
        console.log(error)
        return [];
    }
}

export async function getResponsesForChart(server_ip, id, token) {
    try {
        var fetchCmd = server_ip + "api/surveysresponse/questionOptionsResults";
        const response = await axios.get(fetchCmd, {
            headers: { Authorization: `Bearer ${token}` },
            params: { survId: id }
        });
        //console.log(response.data)
        return response.data;
    } catch (error) {
        console.log(error)
        return [];
    }
}


// Post to API 
export async function postSurveyHeader(server_ip, token, idOfThisElement, organization_id, survey_n, instruct, other_h_info, require_login) {
    var dataSurvey = {
        id: idOfThisElement,
        organization_Id: organization_id,
        survey_name: survey_n,
        instructions: instruct,
        other_header_info: other_h_info,
        require_login: require_login
    }
    // console.log(data);
    axios.post(`${server_ip}/api/Surveys/`, dataSurvey, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
    })
        .then(response => {
            console.log(response)
            return true;
        })
        .catch(error => {
            console.error('There was an error!', error);
            return false;
        });
}


/**
 * Executes a post request to the database to post a section item
 *
 * Example:
 *  we have item s: s.type = survey
 *                  s.id = 107
 *  hhtpPostSections(901, 107, false, "My Section", "Doesn't Matter", "Doesn't Matter") will put "My Section" in database
 *
 * @param {uniqueId} idOfThisElement
 *  id of the section you want to add
 * @param {uniqueId} surv_h_id
 *  id of the survey that the section will belong
 * @param {boolean} section_yn
 *  boolean if this section will be required
 * @param {string} section_n
 *  section name
 * @param {string} section_t
 *  section title (doesn't matter)
 * @param {string} section_sub
 *  section subtext (doesn't matter)
 */
export const postSections = async (server_ip, token, idOfThisElement, surv_h_id, section_yn, section_n, section_t, section_sub) => {
    console.log(token)
    var sectionData = {
        id: idOfThisElement,
        survey_header_id: surv_h_id,
        section_required_yn: section_yn,
        section_name: section_n,
        section_title: section_t,
        section_subheading: section_sub
    }

    await axios.post(`${server_ip}/api/Sections/`, sectionData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
    })
        .then((response) => {
            console.log(response.data)
            // update the Items context
            // return response.data;
        })
        .catch((error) => {
            console.log(error)
            // return [];
        })

}

export const postQuestions = async (server_ip, token, idOfThisElement, p_id, section_id, input_id, q_name,
    q_subtext, q_req_yn, ans_req_yn, option_g_id, allow_mult_yn, dependent_q_id, dependent_q_option, dependent_ans_id) => {
    var questionData = {
        id: idOfThisElement,
        parent_id: p_id,
        survey_section_id: section_id,
        input_type_id: input_id,
        question_name: q_name,
        question_subtext: q_subtext,
        question_required_yn: q_req_yn, answer_required_yn: ans_req_yn,
        option_group_id: option_g_id,
        allow_mutiple_option_answers_yn: allow_mult_yn,
        dependent_question_id: dependent_q_id,
        dependent_question_option_id: dependent_q_option,
        dependent_answer_id: dependent_ans_id,
        question_order: 0,
        question_weight: 0,
    }

    console.log(questionData)
    await axios.post(`${server_ip}/api/questions/`, questionData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
    })
        .then((response) => {
            console.log(response.data)
            // update the Items context
            // return response.data;
        })
        .catch((error) => {
            console.log(error)
            // return [];
        })

}

export const postOptions = async (server_ip, token, idOfThisElement, q_id, fk_option_c, questionOptionName) => {
    var dataOptions = {
        id: idOfThisElement,
        question_id: q_id,
        fk_option_choice_id: fk_option_c,
        question_option_name: questionOptionName
    }
    await axios.post(`${server_ip}/api/Options/`, dataOptions, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
    })
        .then((response) => {
            console.log(response.data)
            // update the Items context
            // return response.data;
        })
        .catch((error) => {
            console.log(error)
            // return [];
        })

}



